export default "__VITE_ASSET__DiWdAp91__"